export interface Duration {
  milliseconds?: number;
  seconds: number;
  minutes?: number;
  hours?: number;
}

// Parses a duration from seconds to a format compatible with Intl.DurationFormat
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/DurationFormat
export function secondsToDuration(seconds: number = 0): Duration {
  const totalSeconds = Math.max(0, Math.round(seconds * 1));
  const sec = totalSeconds % 60;
  const min = Math.floor(totalSeconds / 60) % 60;
  const hrs = Math.floor(totalSeconds / (60 * 60));

  return {
    milliseconds: 0,
    seconds: sec !== 0 ? Math.floor(sec) : 1,
    minutes: min !== 0 ? Math.floor(min) : undefined,
    hours: hrs !== 0 ? Math.floor(hrs) : undefined,
  };
}

export function durationToTimecode(duration: Duration) {
  const { seconds, minutes = '', hours } = duration;
  const timecodeParts = [];

  if (hours && hours > 0) {
    timecodeParts.push(`${hours}`);
  }

  timecodeParts.push(minutes.toString().padStart(hours ? 2 : 1, '0'));
  timecodeParts.push(seconds.toString().padStart(2, '0'));

  return timecodeParts.join(':');
}
